import { headerCommonProps } from "./commonHeaderProps";

const megaMenu = {
  props: {
    classNameMenu: "c-megamenu",
    classNameSubMenus: "c-megamenu__menu",
    classNameSubmenu: "menu-content-name-js",
    classNameMenuBtn: "c-header__switch-btn",
    classNameUnderlay: "c-header-underlay",
    classNameGoBack: "menu-content-go-back-js",
  },

  init: function () {
    const $component = document.getElementsByClassName(this.props.classNameMenu);

    if (!$component || !$component[0]) {
      return;
    }

    this.props.$container = $component[0];

    this.props.$containerUnderlay = this.props.$container.getElementsByClassName(this.props.classNameUnderlay)[0];

    const items = this.props.$container.getElementsByClassName(this.props.classNameSubMenus);

    for (let k = 0; k < items.length; k++) {
      this.initItems(items[k]);
    }

    this.initButtonMenu($component[0]);

    if (bcl.u.mobile.isMobile()) {
      const $images = this.props.$container.getElementsByClassName("cmp-image");

      bcl.u.forEach($images, function ($image) {
        bcl.u.addClass($image, "image-lazy");
      });
    }
  },

  initItems: function ($container) {
    const items = $container.getElementsByClassName(bcl.s.tabs.props.tabSelector);

    for (let k = 0; k < items.length; k++) {
      this.initItem(items[k], $container);
    }
  },

  initItem: function ($item, $container) {
    const $node = $container.querySelector("." + $item.dataset.containertab);

    if ($node) {
      this.addNameInSubmenu($node, $item);
      this.buttonGoBack($node, $item);
    }
  },

  addNameInSubmenu: function ($node, $item) {
    const $nameSubmenu = $node.getElementsByClassName(this.props.classNameSubmenu);

    if ($nameSubmenu && $nameSubmenu[0]) {
      $nameSubmenu[0].innerText = $item.getAttribute("aria-label") || $item.innerText;
    }
  },

  initButtonMenu: function () {
    const $item = headerCommonProps.$container.getElementsByClassName(this.props.classNameMenuBtn)[0];

    if ($item) {
      $item.addEventListener("click", this.clickMenu.bind(this));
    }
  },

  clickMenu: function (e) {
    e.preventDefault();

    if (bcl.u.containsClass(document.body, headerCommonProps.classNameActiveBody)) {
      this.closeMenu(e);
    } else {
      this.openMenu(e);
    }
  },

  openMenu: function (e) {
    const $header = document.querySelector("body > header");
    let top = 0;

    if ($header) {
      const offset = bcl.u.getOffset($header);

      top = 60 + offset.top;

      bcl.u.forEach($header.querySelectorAll(".c-ribbon"), function (ribbon) {
        top += ribbon.offsetHeight;
      });

      if (!this.props.$container.dataset.noTop) {
        this.props.$container.style.top = top + "px";
      }

      const components = document.querySelectorAll(".c-popover.container-contents-JS");

      bcl.u.forEach(components, function ($component) {
        if (!$component.dataset.noTop) {
          $component.style.top = top + "px";
        }
        $component.style.height = window.innerHeight - top + "px";
      });
    }

    bcl.u.addClass(document.body, headerCommonProps.classNameActiveBody);

    bcl.u.addClass(this.props.$containerUnderlay, headerCommonProps.classNameActive);
    bcl.u.addClass(e.target, headerCommonProps.classNameActive);
    bcl.u.addClass(this.props.$container, headerCommonProps.classNameActive);
  },

  closeMenu: function (e) {
    document.body.style.height = "";
    bcl.s.tabs.closeActive();
    bcl.u.removeClass(document.body, headerCommonProps.classNameActiveBody);

    bcl.u.removeClass(this.props.$containerUnderlay, headerCommonProps.classNameActive);
    bcl.u.removeClass(e.target, headerCommonProps.classNameActive);
    bcl.u.removeClass(this.props.$container, headerCommonProps.classNameActive);
    window.dispatchEvent(new CustomEvent("after-click-footer"));
  },

  buttonGoBack: function ($node) {
    const $button = $node.getElementsByClassName(this.props.classNameGoBack);

    if ($button && $button[0]) {
      $button[0].addEventListener("click", function () {
        bcl.s.tabs.closeActive();
        window.dispatchEvent(new CustomEvent("after-click-footer"));
      });
    }
  },

  resize: function () {
    bcl.u.removeClass(document.body, headerCommonProps.classNameActiveBody);
  },
};

export default megaMenu;
